export const saveToLocalStorage = (key: string | undefined, value: unknown) => {
    if (!key) return

    if (!value) {
        localStorage.removeItem(key)
        return
    }

    const valueToStore = typeof value === 'object' ? JSON.stringify(value) : value.toString()
    localStorage.setItem(key, valueToStore)
}

const isJsonString = (str: string): boolean => {
    try {
        JSON.parse(str)
        return true
    } catch (e) {
        return false
    }
}

export const getFromLocalStorage = <T>(key: string | undefined): T | undefined => {
    if (!key) return undefined

    const storedValue = localStorage.getItem(key)
    if (!storedValue) return undefined

    return isJsonString(storedValue) ? JSON.parse(storedValue) as T : (storedValue as unknown as T)
}